import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { GoogleWorkspaceRoutingModule } from './google-workspace-routing.module'
import { TranslateModule } from '@ngx-translate/core'
import { CoreModule } from '../../core.module';
import { CustomTranslateModule } from '@flowaccount/landing'
import { GoogleWorkspaceComponent } from './google-workspace.component'
import { GoogleWorkspaceBannerComponent } from './google-workspace-banner/google-workspace-banner.component'
import { GoogleWorkspaceStartBusinessComponent } from './google-workspace-start-business/google-workspace-start-business.component'
import { GoogleWorkspaceCompleteSolutionsComponent } from './google-workspace-complete-solutions/google-workspace-complete-solutions.component'
import { GoogleWorkspace3StepComponent } from './google-workspace-3-step/google-workspace-3-step.component'
import { GoogleWorkspaceServiceComponent } from './google-workspace-service/google-workspace-service.component'
import { GoogleWorkspaceProductivityComponent } from './google-workspace-productivity/google-workspace-productivity.component'

@NgModule({
  declarations: [
    GoogleWorkspaceComponent,
    GoogleWorkspaceBannerComponent,
    GoogleWorkspaceStartBusinessComponent,
    GoogleWorkspaceCompleteSolutionsComponent,
    GoogleWorkspace3StepComponent,
    GoogleWorkspaceServiceComponent,
    GoogleWorkspaceProductivityComponent,
  ],
  imports: [
    CommonModule,
    GoogleWorkspaceRoutingModule,
    TranslateModule,
    CoreModule.forRoot(),
    CustomTranslateModule.forChild({ path: 'google-workspace' }),
  ],
})
export class GoogleWorkspaceModule {}
